import useAxios from "../../hooks/useAxios";

const useSpectatorAccessService = () => {
  const axiosList = useAxios();
  const axiosAdd = useAxios();
  const axiosUpdate = useAxios();
  const axiosToggleNotify = useAxios();
  const axiosRemove = useAxios();

  const getAllSpectatorAccesses = async () => {
    await axiosList.fetchData({
      url: `/admin/spectator-access`,
      method: "GET",
    });
  };

  const addSpectatorAccess = async (employeeId, approverPositionId, scope) => {
    return await axiosAdd.fetchData({
      url: `/admin/spectator-access/add`,
      method: "POST",
      data: {
        employee_id: employeeId,
        approver_position_id: approverPositionId,
        scope,
      },
    });
  };

  const updateSpectatorAccess = async (id, employeeId, approverPositionId, scope) => {
    return await axiosUpdate.fetchData({
      url: `/admin/spectator-access/update/${id}`,
      method: "POST",
      data: {
        employee_id: employeeId,
        approver_position_id: approverPositionId,
        scope,
      },
    });
  };

  const toggleSpectatorAccessNotify = async (id, notify) => {
    return await axiosToggleNotify.fetchData({
      url: `/admin/spectator-access/toggle-notify/${id}`,
      method: "POST",
      data: { notify },
    });
  };

  const removeSpectatorAccess = async (id) => {
    return await axiosRemove.fetchData({
      url: `/admin/spectator-access/remove/${id}`,
      method: "POST",
    });
  };

  return {
    getAllSpectatorAccesses,
    listLoading: axiosList.loading,
    listResponse: axiosList.response,
    addSpectatorAccess,
    addLoading: axiosAdd.loading,
    updateSpectatorAccess,
    updateLoading: axiosUpdate.loading,
    toggleSpectatorAccessNotify,
    toggleNotifyLoading: axiosToggleNotify.loading,
    removeSpectatorAccess,
    removeLoading: axiosRemove.loading,
  };
};

export default useSpectatorAccessService;
